<template>
  <div class="audiology-kpis__row options-bar">
    <div class="audiology-kpis__filter">
      <StoreConnectedSelect store="audiologyKpis" name="year" :options="yearsList"></StoreConnectedSelect>
    </div>
    <div class="audiology-kpis__filter">
      <StoreConnectedSelect store="audiologyKpis" name="month" :disabled="monthDisabled" :options="monthsInReport"></StoreConnectedSelect>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';

  export default {
    name: 'Filters',
    components: {
      StoreConnectedSelect,
    },
    mounted() {
      this.$store.dispatch('audiologyKpis/getReport');
    },
    computed: {
      ...mapGetters('audiologyKpis', ['month', 'year', 'yearsList', 'monthsInReport', 'activeSection']),
      monthDisabled() {
        return this.activeSection === 'charts';
      },
    },
    watch: {
      year() {
        this.$store.dispatch('audiologyKpis/getReport');
      },
      month() {
        this.$store.dispatch('audiologyKpis/getComments');
      },
    },
  };
</script>
